export var GLOBAL = {
    // url: '/api/', 
    // url_app: '/api/', 
    // url_socket: 'https://app.ciberi.app',

    // url: 'http://localhost:1105/api/',
    // url_app: 'http://localhost:1105/api/',
    // url_socket: 'http://localhost:1105',

    url_socket: 'ws://app.ciberi.app',
    url_app: 'https://app.ciberi.app/api/',  
    url: 'https://app.ciberi.app/api/',
 
    // url: 'http://192.168.0.10/api/',
    // url_app: 'http://192.168.0.10/api/',

    app:true,
    version:'1.1.18',
    company: 'ciberi.app',

    ciberiLocalTunnel : {
        email_aws :'ciberi.tunnel@gmail.com',
        passEmail_aw : '11/ciberi_exitotal/11',
        url:'https://ciberi.co',
        url2025PCC : 'ssh -i "C:/Users/Administrador/Documents/Malawy/Malawy/pem/malawy.pem" ubuntu@ec2-3-19-64-166.us-east-2.compute.amazonaws.com',
        // ciberiAPP: 'ssh -i "C:/Users/Administrador/Documents/ciberi Desarrollo/POS/puntodeventa/frontend/pen/tunnel.pem" ubuntu@ec2-18-217-96-87.us-east-2.compute.amazonaws.com',
        mongodbAtlas:'11/ciber_exitotal/11',
        user_mongodb:'ciberitunnel',
        pass:'ls53hn7mbgZaPWLL',
        mongodump:'mongodump --uri mongodb+srv://ciberireportes:hooUQfSt3re6FsBV@cluster0.dlov49d.mongodb.net/CIBERI'
     }

    
}



// TOKEN PARA APIWATHSAPP
// EAAIBCvRqq94BACnC0nZCLNAHzneVOtbgVttp9FFZC8AUfUV6KpPLEHUZCQ6MNL485DENZAKOajZA9I7L8TS8RX9lTbi1acGU0I0ZCrquBoyV9fH24qnPzwkM1q5E4yKIUZBPlHiZAIgo0qlZAMbboPnVyvCVZBHaYYeiZAR8Qvsa9jAfZBPLZAewZCHn7a

// compilar:
// ionic cordova build android --prod --release
//generar la firma del bundle
// gradlew.bat bundle

//generar la firma del apk
// keytool -genkey -v -keystore ciberi-key.keystore -alias ciberi -keyalg RSA -keysize 2048 -validity 10000
//contraseña: Sistema2143//
// nombre apellido: Juan Ocampo
// dependencua: desarrollo
// nombre organizacion: ciberi
// firmamos todo el paquete
// jarsigner -verbose -sigalg SHA1withRSA -digestalg SHA1 -keystore ciberi-key.keystore app-release-unsigned.apk ciberi
// optimizamos el apk
// zipalign -v 4 app-release-unsigned.apk ciberi.apk

// bundle
// platform android 
// gradlew.bat bundle
// jarsigner -verbose -sigalg SHA1withRSA -digestalg SHA1 -keystore ciberi-key.keystore app-release.aab ciberi
// optimizamos el apk
// zipalign -v 4  app-release.aab ciberi.aab


// compilar web

// ionic build --prod  --build-optimizer --service-worker 



